import Spinner from '@rio-cloud/rio-uikit/Spinner';

import {
    useFetchAccountProfileQuery,
    useFetchPartnerConnectionTypesQuery,
    useFetchPartnersQuery,
} from '../services/partnerNetworkApi';
import Partners from '../features/table/Partners';
import ServiceInfoDialog from '../features/serviceInfoDialog/ServiceInfoDialog';
import { useAppSelector } from '../configuration/setup/hooks';
import { getUserProfile } from '../configuration/login/loginSlice';
import FeedbackPanel from '../features/feedbackPanel/FeedbackPanel';

const Overview = () => {
    const accountId = useAppSelector(getUserProfile)?.account;
    const { isLoading: isPartnersLoading } = useFetchPartnersQuery(undefined, {
        pollingInterval: 20000,
    });
    const { isLoading: isAccountProfileLoading } = useFetchAccountProfileQuery(accountId, { skip: !accountId });
    const { isLoading: isPartnerConnectionTypesLoading } = useFetchPartnerConnectionTypesQuery();
    const isLoading = isPartnersLoading && isAccountProfileLoading && isPartnerConnectionTypesLoading;

    if (isLoading) {
        return (
            <div className='height-100vh'>
                <Spinner isDoubleSized />
            </div>
        );
    }

    return (
        <>
            <Partners />
            <ServiceInfoDialog />
            <FeedbackPanel />
        </>
    );
};

export default Overview;
